/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthorization } from './PalAuthorization';
import {
    PalAuthorizationFromJSON,
    PalAuthorizationFromJSONTyped,
    PalAuthorizationToJSON,
} from './PalAuthorization';

/**
 * 
 * @export
 * @interface FindAllPalAuthorizationsResponse
 */
export interface FindAllPalAuthorizationsResponse {
    /**
     * 
     * @type {Array<PalAuthorization>}
     * @memberof FindAllPalAuthorizationsResponse
     */
    data: Array<PalAuthorization>;
    /**
     * 
     * @type {number}
     * @memberof FindAllPalAuthorizationsResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllPalAuthorizationsResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllPalAuthorizationsResponse
     */
    limit: number;
    /**
     * 
     * @type {boolean}
     * @memberof FindAllPalAuthorizationsResponse
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the FindAllPalAuthorizationsResponse interface.
 */
export function instanceOfFindAllPalAuthorizationsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function FindAllPalAuthorizationsResponseFromJSON(json: any): FindAllPalAuthorizationsResponse {
    return FindAllPalAuthorizationsResponseFromJSONTyped(json, false);
}

export function FindAllPalAuthorizationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalAuthorizationsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PalAuthorizationFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function FindAllPalAuthorizationsResponseToJSON(value?: FindAllPalAuthorizationsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(PalAuthorizationToJSON)),
        'total': value.total,
        'page': value.page,
        'limit': value.limit,
        'has_next': value.has_next,
    };
}

